import api from "../../../utils/api";

export const registerIdentity = async (payload) => {
  const res = await api.post("/identity/register", payload);
  return res.data;
};

export const inviteUser = async (email) => {
  const res = await api.post("/identity/invite", { email });
  return res.data;
};

export const resendInvite = async ({ email, slug }) => {
  const res = await api.post(
    "/identity/invite/resend",
    { email },
    {
      headers: {
        "X-Tenant": slug,
      },
    },
  );
  return res.data;
};

export const resendActivationEmail = async ({ email, slug }) => {
  const res = await api.post(
    "/identity/activate/resend",
    { email },
    {
      headers: {
        "X-Tenant": slug,
      },
    },
  );
  return res.data;
};

export const acceptInvitation = async (tokenHash, userInfo) => {
  const res = await api.post("/identity/invitation/accept", userInfo, {
    params: { token: tokenHash },
  });
  return res.data;
};

export const activateUser = async (tokenHash) => {
  const res = await api.post("/identity/activate", null, {
    params: { token: tokenHash },
  });
  return res.data;
};

export const requestPasswordReset = async (email, slug, turnstileToken) => {
  const res = await api.post("/identity/password-reset/request", { email, slug, turnstileToken });
  return res.data;
};

export const resetPassword = async (tokenHash, newPassword, turnstileToken) => {
  const res = await api.post(
    "/identity/password-reset",
    { new_password: newPassword, turnstileToken },
    { params: { token: tokenHash } },
  );
  return res.data;
};
